export enum OrgTypeEnum {
  Physical = 0,
  Legal,
  LegalBranch,
  Business,
  Agency,
  Stranger,
  StrangerOrg,
}
